<div id="pendingTimesheetReminderModal" class="modal d-flex modal-overlay modal-persistent"
    [ngClass]="{'show': showNotification, 'notification-visible': showNotification, 'notification-hidden': !showNotification}">

    <div class="modal-dialog modal-dialog-centered modal-dialog-custom" (click)="$event.stopPropagation()">
        <div class="modal-content rounded shadow-lg d-flex flex-column custom-notification">
            <div class="modal-header border-0 d-flex align-items-center justify-content-between custom-header">
                <div class="d-flex align-items-center flex-grow-1 overflow-hidden custom-header-title-group">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-bell custom-bell-icon flex-shrink-0 mr-2" viewBox="0 0 16 16" aria-hidden="true">
                        <path
                            d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2M8 1.918l-.797.161A4 4 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4 4 0 0 0-3.203-3.92zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5 5 0 0 1 13 6c0 .88.32 4.2 1.22 6" />
                    </svg>
                    <h5 class="modal-title m-0 custom-title">Timesheet Reminder - Pending Submission</h5>
                </div>
            </div>


            <div class="modal-body d-flex flex-column custom-body">
                <p class="text-start custom-reminder-text">
                    <strong>Action Required:</strong> Please submit your timesheet for the previous working day(s).
                    Below is the list of project(s) you are assigned to.
                    This notification will persist until your timesheet is submitted.
                </p>
                <h6 class="font-weight-bold text-start custom-projects-title">Projects</h6>

                <div class="d-flex flex-column custom-projects-list" [class.projects-loading]="progressActive">
                    <div *ngFor="let project of projects; let i = index; trackBy: trackByName"
                        class="d-flex align-items-center rounded custom-project-item timesheet-reminder-project-item"
                        [id]="'timesheetReminderProject' + i" [ngClass]="{
                           'project-visible': (projectAnimations[i]?.opacity || 0) === 1,
                           'project-hidden': (projectAnimations[i]?.opacity || 0) === 0
                         }">
                        <img src="assets/common/images/new-dashboard/default-project-bag.svg"
                            onError="this.onerror=null; this.src='assets/common/images/new-dashboard/default-project-bag.svg'"
                            alt="Project"
                            class="rounded flex-shrink-0 custom-project-img" />
                        <span class="fw-semibold custom-project-name">{{ project.name }}</span>
                    </div>
                </div>
            </div>


            <div class="modal-footer border-0 d-flex align-items-center justify-content-end custom-footer">
                <button type="button" class="btn custom-skip-btn mr-2" *ngIf="skipVisible"
                    (click)="skipReminder()">Skip for now</button>
                <button type="button" class="btn custom-fill-btn" [class.is-processing]="progressActive"
                    [disabled]="progressActive" (click)="fillTimesheet()">
                    <span class="fill-progress" *ngIf="progressActive" [style.width.%]="progressPercent"></span>
                    <span class="fill-label">Fill Timesheet</span>
                </button>
            </div>

        </div>
    </div>
</div>